import HeadlineWidget from "../Widgets/HeadlineWidget/HeadlineWidgetClass";
import SectionContentWidget from "../Widgets/SectionContentWidget/SectionContentWidgetClass";

const defaultPageInitialContent = {
  body: [
    new SectionContentWidget({
      largeTopPadding: true,
      content: [new HeadlineWidget({ style: "h1" })],
    }),
  ],
  title: "New Page",
  hideInNavigation: "no",
  ShowAiChat: false,
};

const defaultPageProperties = [
  "title",
  "shortTitle",
  "disturberText",
  "disturberLink",
  "disturberValidFrom",
  "disturberValidUntil",
  "hideInNavigation",
  "validFrom",
  "validUntil",
  "description",
  "shortDescription",
  "showAiChat",
];

export { defaultPageInitialContent, defaultPageProperties };
